/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import type { RichText } from './rich-text'

/* TypeScript */
export type RichTextProps = {
  technicalName?: string
  richText: RichText | Record<string, never>
  /**
   * TODO:
   * rework this as all the following properties don't come from the API
   * They are simply used by the <RichText> component independently of the API
   */
  h2Style?: string
  lightText?: boolean
  ignoreLinks?: boolean
  styleVariant?: 'default' | 'light' | 'none'
}

/* Schemas */
export const RichTextPropsSchema = z.object({
  technicalName: z.string().optional(),
  richText: LooseRichTextSchema,
  h2Style: z.string().optional(),
  lightText: z.boolean().optional(),
  ignoreLinks: z.boolean().optional(),
  styleVariant: z.enum(['default', 'light', 'none']).optional(),
})

/* Schemas validation */
type TestRichTextProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<RichTextProps>,
    z.infer<typeof RichTextPropsSchema>
  >
>
